const baseResponseObject = 'msg';

export {baseResponseObject}